import React, { useContext, useEffect, useState } from "react";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { Avatar, Caption1Strong, Image, Menu, MenuDivider, MenuItem, MenuList, MenuPopover, MenuTrigger, Text } from "@fluentui/react-components";
import { callMsGraph, callMsGraphPhoto } from "../../library/MSGraph";
import { loginRequest } from "../../conf/msal/authConfig";
import PageLoading from "../PageLoading";
import { CWClientContext } from "../../App";

/**
 * Renders a sign out button 
 */
export const UserProfile = () => {
    const { instance, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();

    const [graphData, setGraphData] = useState<any>(null);
    const [avaterImage, setAvaterImage] = useState<Blob>();

    const cwClient = useContext(CWClientContext);

    const handleLogout = (logoutType: string) => {
        if (logoutType === "popup") {
            instance.logoutPopup({
                postLogoutRedirectUri: "/",
                mainWindowRedirectUri: "/",
            });
        } else if (logoutType === "redirect") {
            instance.logoutRedirect({
                postLogoutRedirectUri: "/",
            });
        }
    };

    const requestProfileData = () => {
        // Silently acquires an access token which is then attached to a request for MS Graph data
        instance
            .acquireTokenSilent({
                ...loginRequest,
                account: accounts[0],
            })
            .then((response) => {
                callMsGraph(response.accessToken)
                    .then((response) => {
                        setGraphData(response)
                        console.log("setUserName by UserProfile", response.displayName);
                        cwClient.setUserName(response.displayName);
                    });
            });
        instance
            .acquireTokenSilent({
                ...loginRequest,
                account: accounts[0],
            })
            .then((response) => {
                callMsGraphPhoto(response.accessToken).then((response) => {
                    if (response !== null && response !== undefined) {
                        setAvaterImage(response)
                    }
                });
            });
    }


    useEffect(() => {
        requestProfileData();


    }, []);

    const avatar = (() => {
        if (avaterImage !== undefined && avaterImage !== null) {
            return (<Avatar
                image={<Image src={URL.createObjectURL(avaterImage)}></Image>}
            ></Avatar>);
        } else {
            return (<Avatar
            ></Avatar>);
        }
    });

    const menuList = () => {
        if (graphData !== undefined && isAuthenticated && graphData !== null) {
            return (
                <>
                    <MenuItem>
                        {avatar()}&nbsp;
                        {graphData.displayName} <br />
                    </MenuItem>
                    <MenuItem>
                        {graphData.mail}
                    </MenuItem>
                    <MenuDivider />
                    <MenuItem onClick={() => handleLogout("popup")}>
                        サインアウト
                    </MenuItem >
                </>
            )
        } else {
            return (
                <MenuItem>
                    <PageLoading
                        message="プロフィールを読み込み中です。"
                    />
                </MenuItem>
            );
        }
    }


    return (
        <>
            <Menu>
                <MenuTrigger>
                    <Text>
                        <Avatar
                        >
                        </Avatar>
                        &nbsp;
                        {(() => {
                            if (graphData !== undefined && graphData !== null) {
                                return (
                                    <Caption1Strong>
                                        {graphData.displayName}
                                    </Caption1Strong>
                                );
                            } else {
                                return "%displayName%";
                            }
                        })()}
                    </Text>
                </MenuTrigger>
                <MenuPopover>
                    <MenuList>
                        {menuList()}
                    </MenuList>
                </MenuPopover>
            </Menu>
        </>
    );
};

// export type UserProfile = {
//     displayName: string;
//     givenName: string;
//     id: string;
//     jobTitle: string;
//     mail: string;
//     mobilePhone: string;
//     officeLocation: string;
//     prefereredLanguage: string;
//     surname: string;
//     userPrincipalName: string;
// }